import { render, staticRenderFns } from "./Quotas.vue?vue&type=template&id=5c3d441a&"
import script from "./Quotas.vue?vue&type=script&lang=js&"
export * from "./Quotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports